<form class="flex w-full flex-col gap-8" [formGroup]="formGroup" (ngSubmit)="clickSubmit()">
    <div class="flex flex-col items-center">
        <div formArrayName="characters" class="grid grid-cols-6 gap-2 sm:gap-5">
            <mat-form-field
                *ngFor="let control of formArray.controls; let i = index"
                class="h-20 opacity-50 sm:w-12"
                appearance="outline"
                [formGroupName]="i"
            >
                <input
                    #characters
                    matInput
                    class="text-center text-3xl font-extrabold text-primary"
                    formControlName="value"
                    maxlength="1"
                    (focus)="onFocus($event, i)"
                    (keyup)="keyup($event, i)"
                    (paste)="onPaste($event)"
                />
            </mat-form-field>
        </div>

        <mat-error *ngIf="hasValidationError">
            {{ "features.register.invalid_code" | translate }}
        </mat-error>
    </div>

    <div class="flex flex-col gap-6">
        <button class="w-full" mat-flat-button color="accent" [disabled]="validating" (click)="clickSubmit()">
            <div class="flex justify-center" *ngIf="validating; else savingText">
                <mat-spinner [diameter]="24"></mat-spinner>
            </div>

            <ng-template #savingText>
                <span>{{ "general.continue" | translate }}</span>
            </ng-template>
        </button>

        <a class="self-center text-center text-primary underline-offset-2 hover:underline" [routerLink]="['..']">
            {{ "features.register.back_to_login" | translate }}
        </a>
    </div>
</form>
